import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["placeholder", "onChange", "value", "unmask"];
import React, { forwardRef, useRef } from 'react';
import { combineRefs } from '@carnica/utils';
import { Input } from "../../Input";
import { withMaskedInput } from "../../../hocs/withMaskedInput";
var params = {
  mask: [{
    mask: '+{7} 000 000 00 00',
    country: 'Russia',
    startsWith: '8',
    prepare: function prepare(appended, masked) {
      if (appended === '8' && masked.value === '') {
        return '7';
      }
      return appended;
    }
  }, {
    mask: '+7 000 000 00 00',
    startsWith: '+7',
    country: 'Russia'
  }, {
    mask: '+7 000 000 00 00',
    startsWith: '7',
    country: 'Russia'
  }, {
    mask: '+7 000 000 00 00',
    startsWith: '',
    country: 'unknown'
  }],
  dispatch: function dispatch(appended, dynamicMasked) {
    var number = (dynamicMasked.value + appended).replace(/\D/g, '');
    var maskArray = dynamicMasked.compiledMasks;
    return maskArray.find(function (m) {
      return number.indexOf(m.startsWith) === 0;
    });
  }
};
var Phone = withMaskedInput(params, 'tel')(Input);
var getPreparedValue = function getPreparedValue(value, unmask) {
  if (unmask) {
    return value ? "7".concat(value) : '';
  }
  return value;
};
export var PhoneInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? '+7' : _ref$placeholder,
    onChange = _ref.onChange,
    value = _ref.value,
    _ref$unmask = _ref.unmask,
    unmask = _ref$unmask === void 0 ? true : _ref$unmask,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var inputRef = useRef(null);
  var handleChange = function handleChange(newValue, e) {
    onChange === null || onChange === void 0 ? void 0 : onChange(newValue, e);
  };
  return /*#__PURE__*/React.createElement(Phone, _extends({
    onChange: handleChange,
    placeholder: placeholder,
    ref: combineRefs([ref, inputRef]),
    unmask: unmask,
    value: getPreparedValue(value, unmask)
  }, otherProps, {
    "data-t-id": "AdvancedInputs-PhoneInput"
  }));
});